exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#createPassword .heading{padding:5px 0 10px;font-size:1.6em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}#createPassword .msg{padding-top:10px}#createPassword .continueBtn{margin:10px 0}#createPassword .cancelLink{width:100%;text-align:center;padding-top:10px}#createPassword .cancelLink a{cursor:pointer}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){#createPassword{padding-top:40px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader!./components/xo-login-components/src/create-password/styles.less
// module id = ../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-login-components/src/create-password/styles.less
// module chunks = 1